import React from 'react'
import SettingsRecaptchaForm from '../components/setting/settingsRecaptchaForm'

const SettingsRecaptcha = () => {
  return (
    <><SettingsRecaptchaForm/></>
  )
}

export default SettingsRecaptcha